module.exports = __webpack_public_path__ + "static/img/bannerNew1.f972a30.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/bannerNew1.webp
// module id = wB1T
// module chunks = 1